<template>
  <ibox>
    <template slot="title">会員登録</template>
    <template slot="body">
      <member-form></member-form>
    </template>
  </ibox>
</template>

<script>
import MemberForm from '../../components/member/Form.vue'

export default {
  data () {
    return {
    }
  },
  components: {
    MemberForm
  }
}
</script>




// WEBPACK FOOTER //
// Create.vue?f2a662ea